import React, { useEffect } from 'react';
import { siteUrl } from '../../config';

const FastFoodSolutionPage = () => {
  useEffect(() => {
    document.title = 'Fast Food Dijital Çözümü | Hızlı POS, Online Sipariş, Kurye, QR Menü';
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    meta.setAttribute('content', 'Fast food işletmeleri için hızlı POS, QR menü, online sipariş ve kurye takibi. Hızlı servis, tek panel yönetim, komisyonsuz sipariş.');

    // Canonical
    const canonicalHref = `${siteUrl}/solutions/fastfood`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalHref);

    const structured = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Fast Food Dijital Çözümü',
      serviceType: 'Hızlı Servis Otomasyon Sistemi',
      areaServed: 'TR'
    };
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structured);
    document.head.appendChild(script);
    return () => {
      if (script && script.parentNode) document.head.removeChild(script);
      if (canonical && canonical.parentNode && canonical.getAttribute('href') === canonicalHref) {
        document.head.removeChild(canonical);
      }
    };
  }, []);

  return (
    <main className="bg-white">
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="font-poppins font-heading-bold text-3xl md:text-5xl text-foreground mb-4">Fast Food için Dijital Çözüm</h1>
          <p className="font-open-sans text-lg text-text-secondary mb-8">Hızlı servis operasyonları için optimize edilmiş POS, online sipariş ve kurye akışı. QR Menü ile hatasız iletişim ve daha hızlı sipariş.</p>
          <div className="flex flex-wrap gap-3 mb-10">
            <a href="https://panel.cafeotomasyonu.com/sign-up" className="px-6 py-3 rounded-lg bg-primary text-white font-poppins font-heading-semibold">Ücretsiz Kayıt Ol</a>
            <a href="https://menu.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">QR Menü Demo</a>
            <a href="https://online.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">Online Sipariş Demo</a>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Öne Çıkanlar</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>Hızlı kasiyer akışı ve tek dokunuş eylemler</li>
                <li>Hazır menü–menü kombinasyon yönetimi</li>
                <li>Kurye rota ve teslimat süreleri analizi</li>
                <li>Yoğunluk saatlerine göre AI önerileri</li>
              </ul>
            </div>
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Deneme Süreleri</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>QR Menü: Süresiz ücretsiz</li>
                <li>Yapay Zeka: 15 gün ücretsiz</li>
                <li>POS / Online Sipariş / Kurye: 30 gün ücretsiz</li>
              </ul>
            </div>
          </div>

          <section className="mt-10 space-y-6 text-text-secondary">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground">Hızlı Servis İşletmeleri İçin Modüller</h2>
            <p>Hızlı kasa akışı, menü kombinasyonları ve teslimat süreleri fast food işletmelerinin temel metrikleridir. Aşağıdaki modüllerle verimliliği artırın.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">POS Sistemi</h3>
            <p><a className="text-primary underline" href="/pos-system">POS</a> ile tek dokunuş eylemler, kombinasyon menüler ve çoklu yazıcı desteği.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Online Sipariş</h3>
            <p><a className="text-primary underline" href="/online-order">Online Sipariş</a> ile yoğun saatlerde bile komisyonsuz akış; min. sepet ve kampanya yönetimi.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Kurye</h3>
            <p><a className="text-primary underline" href="/courier-system">Kurye</a> performansı, rota ve teslimat süreleri ile KPI takibi yapın.</p>
            <h3 className="font-poppins font-heading-semibold text-xl">Yapay Zeka</h3>
            <p><a className="text-primary underline" href="/ai-system">AI</a> ile yoğunluk tahmini ve çapraz satış önerileriyle ticket size’ı artırın.</p>
          </section>

          <section className="mt-10">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground mb-4">Sıkça Sorulan Sorular</h2>
            <div className="space-y-4">
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Kombinasyon menüler destekleniyor mu?</summary>
                <p className="mt-2">Evet. POS tarafında set/menü kombinasyonları tanımlanabilir.</p>
              </details>
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Kurye performansı nasıl izlenir?</summary>
                <p className="mt-2">Teslimat süreleri, rota ve online/offline durumları panelden raporlanır.</p>
              </details>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
};

export default FastFoodSolutionPage;


